<template>
    <guest-layout>
        <div class="wrap-login" v-if="!loading">
            <div class="verified-wrap" v-if="!error">
                <img src="/assets/images/check.svg">
                <p>Email berhasil dikonfirmasi</p>
            </div>
            <div class="verified-wrap" v-else>
                <img src="/assets/images/close.svg">
                <p>Kode verifikasi tidak valid</p>
            </div>
        </div>
    </guest-layout>
</template>
<script>
import axios from "axios";

export default {
    data() {
        return {
            loading: true,
            error: false
        }
    },
    mounted() {
        this.verification()
    },
    methods: {
        async verification() {
            const form = this.$route.query;
            await axios.post('/api/register/confirmation', form)
                .then((response) => {
                    this.$notify({
                        duration: 5000,
                        group: 'main',
                        title: 'Berhasil!',
                        text: response.data.message,
                        type: 'success'
                    })
                    if(form.ref =="iklandisini")
                    {
                       window.open('https://www.iklandisini.com/landing/confirmation', '_blank'); 
                    }else if(form.ref =="serbada")  {  
                      window.open('https://www.serbada.com/landing/confirmation', '_blank'); 
                    }else{
                        this.$router.push({name: 'login'});
                    } 
                    this.loading = false
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = true;
                });
        }
    }
}
</script>
<style>
.wrap-login {
    padding: 4%;
    margin-top: 15px;
}
</style>
